// hooks/useCopyWithToast.js
import { useState } from 'react';

export const useCopyWithToast = () => {
  const [isCopying, setIsCopying] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const copyWithToast = async (text, toastCallback) => {
    if (!text) return false;
    
    setIsCopying(true);
    setIsCopied(false);
    
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      
      setIsCopied(true);
      
      if (toastCallback) {
        toastCallback('success', 'Copied to clipboard!');
      }
      
      // Auto reset after 2 seconds
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
      
      return true;
    } catch (err) {
      console.error('Failed to copy: ', err);
      if (toastCallback) {
        toastCallback('error', 'Failed to copy');
      }
      return false;
    } finally {
      setIsCopying(false);
    }
  };

  return {
    copyWithToast,
    isCopying,
    isCopied
  };
};